import { AppLauncher } from "@capacitor/app-launcher";
import { WebPlugin, registerPlugin } from "@capacitor/core";
import { isNativeMobile, isNativePlatform } from 'src/app/shared/utils/platform.utils';
import { MetaMaskSDK, SDKProvider } from '@metamask/sdk';

interface IMetamaskConnectResponse {
    address: string,
    chainId: string
}

export interface MetamaskPlugin {
    connect(): Promise<IMetamaskConnectResponse>;
}

export class MetamaskWeb extends WebPlugin implements MetamaskPlugin {
    initializePromise: Promise<void>;

    metamaskProvider: SDKProvider;

    constructor(
    ) {
        super()
    }
    
    private initMetamask() {
        if (!this.initializePromise) this.initializePromise = this.connectToMetamaskProvider();
        return this.initializePromise;
    }

    private async connectToMetamaskProvider(){
        const MMSDK = new MetaMaskSDK({
            dappMetadata:  {
                name: 'SoPo - Social Poker',
                url: 'https://app.playsopo.com/',
            },
            extensionOnly: true,
            openDeeplink: (deepLink) => {this.openMetamask(deepLink)},
        });
        await MMSDK.init();

        this.metamaskProvider = MMSDK.getProvider();
    }

    private async openMetamask(deepLink: string) {
        if (!isNativePlatform()) return;
        const launchResult = await AppLauncher.openUrl({
            url: deepLink
        });
    }

    async connect(): Promise<IMetamaskConnectResponse> {
        await this.initMetamask()
        const result = await this.metamaskProvider.request({ method: 'eth_requestAccounts' });
        const chainId = this.metamaskProvider.getChainId();
        return {
            address: result[0],
            chainId
        };
    }
}

const Metamask = registerPlugin<MetamaskPlugin>('Metamask', {
    web: () => new MetamaskWeb()
  },
);

export default Metamask;
